import { Pagination } from "@mui/material";
import {
  ArchiveIcon,
  AvatarIcon,
  CalendarIcon,
  HomeIcon,
  Pencil1Icon,
  PersonIcon,
  SewingPinFilledIcon,
} from "@radix-ui/react-icons";
import { useEffect, useState } from "react";
import ReactDatePicker from "react-datepicker";
import toast from "react-hot-toast";
import { NavLink } from "react-router-dom";
import {
  checkTagValidity,
  getUserProfil,
  months,
  years,
} from "../../Utils/Utils";
import {
  BASE_URL,
  EN_ATTENTE_INSTALLATION,
  EXPORT_RAPPORT,
  LIST_SOUSCRIPTION,
  SHOW_PASSWORD,
} from "../../Utils/constant";
import { UpdateActivation } from "../../components/Ajouter-intention/UpdateActivation";
import { ContentLoading } from "../../components/Widget/ContentLoading";
import { Pbo } from "../../components/Widget/Pbo";
import { Periode } from "../../components/Widget/Periode";
import { Tabs } from "../../components/Widget/Tab";
import { find } from "../../services/service";
import { useCommentaireStore } from "../../store/CommentaireStore";
import { useStoreLivraison } from "../../store/livraisonStore";
import { useStoreApp } from "../../store/storeApp";

const Installation = () => {
  const [filterByResult, setFilterByResult] = useState("OK");
  const [numeroTicket, setNumeroTicket] = useState(null);
  const [dateRange, setDateRange] = useState([null, null]);
  const [startDate, endDate] = dateRange;
  const [select, setSelect] = useState("ANNEE");
  const [showPassword, setShowPassword] = useState(null);
  const [active, setActive] = useState({
    index: 0,
    value: "En Attente d'installation",
    tag: "LISTE_EN_ATTENTE_INSTALLATION",
  });
  const [tab, setTab] = useState([
    {
      index: 0,
      value: "En Attente d'installation",
      tag: "LISTE_EN_ATTENTE_INSTALLATION",
    },
    {
      index: 1,
      value: "Installé",
      tag: "LISTE_INSTALLER",
    },
  ]);

  const filteredTabsData = tab
    .filter((tab) => checkTagValidity(tab.tag))
    .map((tab, index) => ({ ...tab, index }));

  const showPasswordAAA = (tiket) => {
    find(SHOW_PASSWORD + `?numeroTicket=${tiket}`)
      .then((res) => {
        setShowPassword(res?.data?.donnee);
      })
      .catch((error) => {
        toast.error("Une erreur est survenue");
        console.error(error);
      });
  };

  useEffect(() => {
    if (filteredTabsData.length !== 0) {
      setActive(filteredTabsData[0]);
      setTab(filteredTabsData);
    }
  }, []);

  const more = (page) => {
    store.getData(
      LIST_SOUSCRIPTION,
      { page: page - 1, param: "", size: 6 },
      `&periode=&mois=&annee=&dateDebut=&dateFin=&inTime=`,
    );
  };

  const moreEnAttenteInstallation = (page) => {
    activation.getData(
      EN_ATTENTE_INSTALLATION,
      { page: page - 1, param: "", size: 6 },
      `&periode=&mois=&annee=&dateDebut=&dateFin=&inTime=`,
    );
  };

  const store = useStoreLivraison();
  const activation = useStoreApp();
  const commentaire = useCommentaireStore();

  useEffect(() => {
    store.getData(
      LIST_SOUSCRIPTION,
      { page: 0, param: "", size: 6 },
      `&periode=&mois=&annee=&dateDebut=&dateFin=&inTime=`,
    );
    commentaire.getData("page=0&param=&size=10000000");
    activation.getData(
      EN_ATTENTE_INSTALLATION,
      { page: 0, param: "", size: 6 },
      "&inTime=",
    );
  }, []);

  const handleDownload = () => {
    const user = getUserProfil();
    fetch(
      `${BASE_URL + EXPORT_RAPPORT}?model=ACTIVATIONS&username=${
        user?.username
      }`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({}),
      },
    )
      .then((response) => response.blob())
      .then((blob) => {
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.style.display = "none";
        a.href = url;
        a.download = `RAPPORT_ACTIVATIONS.xlsx`; // spécifiez le nom du fichier et son extension
        document.body.appendChild(a);
        a.click();
      })
      .catch((err) => console.error("Erreur de téléchargement:", err));
  };

  return (
    <div className="">
      <div className="lg:flex gap-8 items-center ">
        <h3 class="font-mtn text-3xl font-bold">Installation</h3>
        <div className="ml-auto lg:flex gap-x-3">
          <select
            onChange={(e) => {
              setSelect(e.target.value);
            }}
            className="my-2 select"
          >
            <option>Periode</option>
            <option value="MOIS">Filtre par mois</option>
            <option value="ANNEE" selected>
              Filtre par années
            </option>
          </select>
          {select === "MOIS" ? (
            <select onChange={(e) => {}} className="my-2 select">
              <option disabled selected>
                mois
              </option>
              {months.map((item) => (
                <option value={item.code}>{item.name}</option>
              ))}
            </select>
          ) : select === "ANNEE" ? (
            <select onChange={(e) => {}} className="my-2 select ">
              <option disabled selected>
                années
              </option>
              {years.map((item) => (
                <option
                  value={item.name}
                  selected={
                    new Date().getFullYear() === Number(item.name)
                      ? true
                      : false
                  }
                >
                  {item.name}
                </option>
              ))}
            </select>
          ) : (
            <ReactDatePicker
              dateFormat="dd-MM-yyyy"
              selected={startDate}
              onChange={(update) => {
                if (update[1] != null) {
                }
                setDateRange(update);
              }}
              startDate={startDate}
              endDate={endDate}
              selectsRange
              className="text-xs font-normal cursor-pointer btn btn-sm hover:bg-gray-100 text-center h-8 my-2 w-52 rounded-md border border-input bg-gray-100 px-3 py-1 shadow-sm"
            />
          )}
        </div>
      </div>

      <Tabs tabsData={filteredTabsData} active={active} setActive={setActive} />
      <div className="bg-white rounded-md px-2 py-4 mt-3">
        <div className="mt-3 lg:flex gap-1 items-center">
          <input
            type="text"
            placeholder="Rechercher element..."
            className="text-xs input input-bordered px-3 w-80 h-10 text-gray-900 placeholder:text-gray-400"
            onChange={(e) =>
              active.index === 0
                ? activation.getData(
                    EN_ATTENTE_INSTALLATION,
                    { page: 0, param: e.target.value, size: 6 },
                    `&inTime=`,
                  )
                : store.getData(
                    LIST_SOUSCRIPTION,
                    { page: 0, param: e.target.value, size: 6 },
                    `&periode=&mois=&annee=&dateDebut=&dateFin=&inTime=`,
                  )
            }
          />

          {active.index === 1 ? (
            <>
              <select
                onChange={(e) =>
                  store.getData(
                    LIST_SOUSCRIPTION,
                    { page: 0, param: "", size: 6 },
                    `&periode=&mois=&annee=&dateDebut=&dateFin=&inTime=${e.target.value}`,
                  )
                }
                className="select pl-non my-3"
              >
                <option disabled selected>
                  Delais de traitement
                </option>
                <option value="">Tout afficher</option>
                <option value={"true"}>Intention dans le delais</option>
                <option value={"false"}>Intention hors delais</option>
              </select>
            </>
          ) : (
            <select
              onChange={(e) =>
                activation.getData(
                  EN_ATTENTE_INSTALLATION,
                  { page: 0, param: "", size: 6 },
                  `&inTime=${e.target.value}`,
                )
              }
              className="select pl-non my-3"
            >
              <option disabled selected>
                Delais de traitement
              </option>
              <option value="">Tout afficher</option>
              <option value={"true"}>Intention dans le delais</option>
              <option value={"false"}>Intention hors delais</option>
            </select>
          )}
        </div>

        {active.index === 0 ? (
          <>
            <div className=" grid  lg:grid-cols-3 md:grid-cols-3 sm:grid-cols-2 mt-4 grid-cols-1 gap-5">
              {activation?.data?.data?.length === 0 ? (
                <div className="">
                  <p className="text-sm ">Aucune donnée </p>
                </div>
              ) : activation?.data?.data?.length !== 0 &&
                !activation?.loading ? (
                activation?.data?.data?.map((item) => (
                  <div className="relative bg-white rounded-xl border-slate-200 border shadow-md">
                    <div className="rounded-t-xl flex items-center gap-3 border-b border-dashed border-amber-400 px-2 py-3">
                      <p className="text-[12px] font-semibold">
                        N° {item?.abonnement?.eligibilite?.numeroTicket}
                      </p>
                    </div>
                    <div className=" px-3 py-2 ">
                      <div className="items-center gap-2 space-y-3">
                        <Periode item={item} />
                        <Pbo
                          pbo={item?.abonnement?.eligibilite?.pbo?.nom}
                          port={item?.brin}
                        />
                        <div className="flex gap-1 my-3">
                          <PersonIcon className="bg-gray-100 rounded-full w-8 h-8 p-2" />
                          <div>
                            <p className="text-[13px] font-medium">
                              {item?.abonnement?.client?.nomPrenoms}
                            </p>
                            <p className="text-xs flex font-semibold gap-2">
                              <span>{item?.abonnement?.client?.numero}</span>{" "}
                              {" | "}{" "}
                              <span>
                                {item?.abonnement?.client?.secondNumero}
                              </span>{" "}
                            </p>
                          </div>
                        </div>

                        <h1 className="text-xs flex gap-1 items-center my-2">
                          Forfait : {item?.abonnement?.forfait?.designation} -{" "}
                          {item?.abonnement?.forfait?.categorie
                            ?.replace("_", "")
                            .toLowerCase()}
                        </h1>
                        <div className="gap-1 ">
                          <div>
                            <p className="text-[13px] font-medium">
                              Numero FTTH : {item?.abonnement?.numeroFtth}
                            </p>
                            {/* <p className="text-xs flex font-semibold gap-2">
                              SN : <span>{item?.abonnement?.numeroSerie}</span>
                            </p> */}
                          </div>
                        </div>
                        <h1 className="text-xs flex gap-1 items-center my-2">
                          <AvatarIcon />
                          Equipe en charge : {item?.equipe?.designation}
                        </h1>

                        <div className="pb-3 pt-1 border-b flex gap-4 items-center">
                          <p className="text-xs flex gap-1 items-center font-medium">
                            <HomeIcon />
                            {item?.batiment?.designation}
                          </p>
                          <p className="text-xs flex gap-1 font-medium">
                            <ArchiveIcon /> {item?.equipement?.designation}{" "}
                          </p>
                        </div>
                      </div>
                      <h1 className="my-2 text-[13px] font-medium flex items-center">
                        <SewingPinFilledIcon />
                        {item?.abonnement?.commune +
                          ", " +
                          item?.abonnement?.quartier}
                      </h1>
                      <div className="flex items-center gap-1">
                        <h5 className="text-xs font-medium ">Etape:</h5>
                        <p className=" bg-blue-50 text-blue-900 py-1 px-1 rounded-lg font-medium text-xs truncate">
                          {item?.abonnement?.status ===
                            "EN_ATTENTE_DE_ACTIVATION" ||
                          item?.abonnement?.status ===
                            "EN_ATTENTE_DE_SOUSCRIPTION"
                            ? "en attente d'installation"
                            : ""}
                        </p>
                      </div>
                      {checkTagValidity("POURSUIVRE_INSTALLATION") ? (
                        <NavLink
                          onClick={() => {
                            localStorage.setItem(
                              "etape",
                              item?.abonnement?.status,
                            );
                          }}
                          className="btn btn-sm bg-main my-3 font-mtn text-xs font-regular"
                          to={`poursuivre-intention/${item?.abonnement?.eligibilite?.numeroTicket}/7`}
                        >
                          Poursuivre
                        </NavLink>
                      ) : null}
                    </div>
                  </div>
                ))
              ) : (
                <ContentLoading />
              )}
            </div>
            <div className="my-3 flex justify-end">
              <Pagination
                onChange={(event, newValue) =>
                  moreEnAttenteInstallation(newValue)
                }
                onSelect={(selectedPage) =>
                  moreEnAttenteInstallation(selectedPage)
                }
                count={activation?.data?.totalPages}
                variant="outlined"
                color="primary"
                shape="rounded"
              />
            </div>
          </>
        ) : active.index === 1 ? (
          <>
            <div>
              <div className="grid md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-3 2xl:grid-cols-3 gap-2 my-4">
                {store?.data?.data?.length === 0 ? (
                  <div className="flex justify-center items-center">
                    <p>Aucune donnée</p>
                  </div>
                ) : store?.data?.data?.length !== 0 && !store?.loading ? (
                  store?.data?.data?.map((item) => (
                    <div
                      className={`${
                        !item?.inTime
                          ? "border-red-300 border-2 border-dashed"
                          : "border-slate-200 border"
                      } relative bg-white rounded-xl  shadow-sm`}
                    >
                      <div className="rounded-t-xl flex items-center gap-3 border-b-[2px] border-orange-100 px-4 py-3">
                        <p className="text-[12px] font-semibold">
                          Ticket N°{item?.abonnement?.eligibilite?.numeroTicket}
                        </p>
                        <p className="text-red-500 text-xs">
                          {!item?.inTime ? "Hors delais" : ""}
                        </p>
                      </div>
                      <div className="px-3 py-2">
                        <div className="my-1 flex items-center">
                          <div className="flex items-center gap-2">
                            <Pbo
                              pbo={item?.abonnement?.eligibilite?.pbo?.nom}
                              port={item?.brin}
                            />
                          </div>
                        </div>
                        <div className="items-center gap-2 space-y-3">
                          <h1 className="text-xs flex items-center my-2">
                            <SewingPinFilledIcon />
                            Lieu de raccordement :{" "}
                            {item?.abonnement?.commune +
                              ", " +
                              item?.abonnement?.quartier}
                          </h1>
                          <h1 className="text-xs flex gap-1 items-center my-2">
                            Forfait : {item?.abonnement?.forfait?.designation} -{" "}
                            {item?.abonnement?.forfait?.categorie
                              ?.replace("_", "")
                              .toLowerCase()}
                          </h1>
                          <div className=" gap-1 ">
                            <div>
                              <p className="text-[13px] font-medium">
                                Numero FTTH : {item?.abonnement?.numeroFtth}
                              </p>
                              <p className="text-xs flex font-semibold gap-2">
                                SN :{" "}
                                <span>{item?.abonnement?.numeroSerie}</span>
                              </p>
                            </div>
                          </div>
                          <h1 className="text-xs flex gap-1 items-center my-2">
                            <AvatarIcon />
                            Réaliser par :{" "}
                            {item?.agent?.nomPrenoms +
                              " | " +
                              item?.agent?.numero}
                          </h1>
                          {item?.prestataire?.designation ? (
                            <h1 className="text-xs flex gap-1 p-1 w-fit rounded items-center my-2">
                              Prestataire : {item?.prestataire?.designation}
                            </h1>
                          ) : null}
                          <div className="pb-3 border-b gap-4 items-center">
                            <p className="text-xs flex gap-1 items-center font-medium">
                              <CalendarIcon /> Date d'activation :{" "}
                              {item?.dateActivation
                                ? new Date(
                                    item?.dateActivation,
                                  ).toLocaleString()
                                : "--"}
                            </p>
                            <div className="mt-2 flex items-center">
                              <p className="text-xs font-medium text-blue-700">
                                Commentaire: {item?.commentaire}{" "}
                              </p>
                            </div>
                          </div>

                          <div className="flex gap-1 ">
                            <PersonIcon className="bg-gray-100 rounded-full w-8 h-8 p-2" />
                            <div>
                              <p className="text-[13px] font-medium">
                                {item?.abonnement?.client?.nomPrenoms}
                              </p>
                              <p className="text-xs flex font-semibold gap-2">
                                <span>{item?.abonnement?.client?.numero}</span>{" "}
                                {" | "}{" "}
                                <span>
                                  {item?.abonnement?.client?.email}
                                </span>{" "}
                              </p>
                            </div>
                          </div>

                          {item.resultat === "OK" ? null : checkTagValidity(
                              "MODIFIER_ACTIVATION",
                            ) ? (
                            <button
                              onClick={() => {
                                setNumeroTicket(
                                  item?.abonnement?.eligibilite?.numeroTicket,
                                );
                                document.getElementById("edit").showModal();
                              }}
                              className="ml-auto text-white text-xs btn btn-sm bg-black"
                            >
                              <Pencil1Icon /> Modifier
                            </button>
                          ) : null}
                          <button
                            onClick={() => {
                              document
                                .getElementById(`show${item.id}`)
                                .showModal();
                            }}
                            className="btn btn-sm bg-main text-xs"
                          >
                            Details
                          </button>

                          <dialog
                            id={`show${item.id}`}
                            className="modal bg-slate-900/70"
                          >
                            <div className="modal-box w-11/12 max-w-2xl">
                              <div className="flex items-center justify-between p-3">
                                <div className="flex flex-row gap-2">
                                  <div className=" flex justify-center items-center rounded-full bg-[#ffcb05] w-8 h-8"></div>
                                  <h2 className="font-extrabold flex flex-row items-center text-sm text-[#000000a8]">
                                    Details de l'activation
                                  </h2>
                                </div>
                                <form method="dialog">
                                  <button
                                    id="fermer_create_trajet"
                                    className="w-8 h-8 flex items-center justify-center rounded-lg bg-red-100 hover:bg-red-200 text-red-600 hover:text-red-600 font-semibold"
                                  >
                                    ✕
                                  </button>
                                </form>
                              </div>
                              <div>
                                <div className="">
                                  <div className="bg-white p-3 rounded-lg border">
                                    <div className="px-4 sm:px-0">
                                      <h3 className="lg:text-lg text-2xl text-gray-900 font-bold">
                                        Ticket N°
                                        {
                                          item?.abonnement?.eligibilite
                                            ?.numeroTicket
                                        }
                                      </h3>
                                    </div>
                                    <div className="mt-3 border-t border-gray-100">
                                      <dl className="divide-y divide-gray-100">
                                        <div className="px-4 py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                                          <dt className="text-sm font-semibold text-gray-900">
                                            Client
                                          </dt>
                                          <dd className="mt-1 text-sm font-medium leading-6  sm:col-span-2 sm:mt-0">
                                            {
                                              item?.abonnement?.client
                                                ?.nomPrenoms
                                            }
                                          </dd>
                                        </div>

                                        <div className="px-4 py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                                          <dt className="text-sm font-semibold leading-6 text-gray-900">
                                            Email
                                          </dt>
                                          <dd className="mt-1 text-sm font-medium leading-6  sm:col-span-2 sm:mt-0">
                                            {item?.abonnement?.client?.email}
                                          </dd>
                                        </div>
                                        <div className="px-4 py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                                          <dt className="text-sm font-semibold leading-6 text-gray-900">
                                            Contact client
                                          </dt>
                                          <dd className="mt-1 text-sm font-medium leading-6 sm:col-span-2 sm:mt-0">
                                            {item?.abonnement?.client?.numero}
                                          </dd>
                                        </div>
                                        <div className="px-4 py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                                          <dt className="text-sm font-semibold leading-6 text-gray-900">
                                            Numero avantage
                                          </dt>
                                          <dd className="mt-1 text-sm font-medium leading-6 sm:col-span-2 sm:mt-0">
                                            {item?.abonnement?.numeroMtn}
                                          </dd>
                                        </div>
                                        <div className="px-4 py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                                          <dt className="text-sm font-semibold leading-6 text-gray-900">
                                            Ville du client
                                          </dt>
                                          <dd className="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">
                                            {
                                              item?.abonnement?.domicile
                                                ?.quartier?.commune?.designation
                                            }
                                          </dd>
                                        </div>
                                        <div className="px-4 py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                                          <dt className="text-sm font-semibold leading-6 text-gray-900">
                                            Quartier
                                          </dt>
                                          <dd className="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">
                                            {
                                              item?.abonnement?.domicile
                                                ?.quartier?.designation
                                            }
                                          </dd>
                                        </div>

                                        <div className="px-4 py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                                          <dt className="text-sm font-semibold leading-6 text-gray-900">
                                            Status d'éligibilité
                                          </dt>
                                          <dd className="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">
                                            {item?.abonnement?.eligibilite
                                              ?.ftthEligible === "yes"
                                              ? "Eligible"
                                              : "Pas eligible"}
                                          </dd>
                                        </div>

                                        <div className="px-4 py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                                          <dt className="text-sm font-semibold leading-6 text-gray-900">
                                            Forfait souhaité
                                          </dt>
                                          <dd className="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">
                                            {
                                              item?.abonnement?.forfait
                                                ?.designation
                                            }
                                          </dd>
                                        </div>
                                      </dl>
                                    </div>
                                  </div>
                                </div>
                                <div className="">
                                  <p className="my-4 font-bold text-lg">
                                    Information sur l'activation
                                  </p>
                                  <div className="bg-white p-3 rounded-lg border">
                                    <div className="">
                                      <dl className="divide-y divide-gray-100">
                                        <div className="px-4 py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                                          <dt className="text-sm font-semibold text-gray-900">
                                            Mot de passe
                                          </dt>
                                          <dd className="mt-1 text-sm font-medium leading-6 text-blue-700 sm:col-span-2 sm:mt-0 flex items-center justify-between gap-2">
                                            {showPassword
                                              ? showPassword
                                              : (item?.abonnement
                                                  ?.mdpActivation ?? "--")}
                                            <button
                                              className="px-2 py-1 rounded-md text-xs bg-black text-white"
                                              onClick={() => {
                                                if (showPassword) {
                                                  setShowPassword(null);
                                                } else {
                                                  showPasswordAAA(
                                                    item?.abonnement
                                                      ?.eligibilite
                                                      ?.numeroTicket,
                                                  );
                                                }
                                              }}
                                            >
                                              {showPassword
                                                ? "Masquer mot de passe"
                                                : "Afficher mot de passe"}
                                            </button>
                                          </dd>
                                        </div>
                              

                                        <div className="px-4 py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                                          <dt className="text-sm font-semibold leading-6 text-gray-900">
                                            Realisé par:
                                          </dt>
                                          <dd className="mt-1 text-sm font-medium leading-6 text-blue-700 sm:col-span-2 sm:mt-0">
                                            {item?.agent?.nomPrenoms}
                                          </dd>
                                        </div>

                                        <div className="px-4 py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                                          <dt className="text-sm font-semibold leading-6 text-gray-900">
                                            Commentaire
                                          </dt>
                                          <dd className="mt-1 text-sm font-medium leading-6 text-blue-700 sm:col-span-2 sm:mt-0">
                                            {item?.commentaire}
                                          </dd>
                                        </div>
                                      </dl>
                                    </div>
                                  </div>
                                </div>
                                <div className="rounded-lg">
                                  <div className="sm:px-0">
                                    <p className="my-4 font-bold text-lg">
                                      Information sur la souscription
                                    </p>
                                  </div>
                                  <div className="mt-2 border-t border-gray-100">
                                    <dl className="divide-y divide-gray-100">
                                      <div className="px-4 py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                                        <dt className="text-sm font-bold leading-6 text-gray-900">
                                          Forfait souscrit
                                        </dt>
                                        <dd className="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">
                                          {item?.abonnement?.forfait
                                            ?.designation ?? "--"}
                                        </dd>
                                      </div>

                                      <div className="px-4 py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                                        <dt className="text-sm font-bold leading-6 text-gray-900">
                                          Categorie du forfait
                                        </dt>
                                        <dd className="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">
                                          {item?.abonnement?.forfait
                                            ?.categorie ?? "--"}
                                        </dd>
                                      </div>

                                      <div className="px-4 py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                                        <dt className="text-sm font-bold leading-6 text-gray-900">
                                          OfferId
                                        </dt>
                                        <dd className="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">
                                          {item?.abonnement?.forfait?.offerId ??
                                            "--"}
                                        </dd>
                                      </div>

                                      <div className="px-4 py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                                        <dt className="text-sm font-bold leading-6 text-gray-900">
                                          Equipement
                                        </dt>
                                        <dd className="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">
                                          {item?.abonnement?.forfait?.equipement
                                            ?.designation ?? "--"}
                                        </dd>
                                      </div>
                                    </dl>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </dialog>
                        </div>
                      </div>
                    </div>
                  ))
                ) : (
                  <ContentLoading />
                )}
                <dialog id="edit" className="modal ">
                  <div className="modal-box">
                    <div className="modal-action">
                      <h1 className="mr-auto text-2xl font-bold font-mtn">
                        Activation
                      </h1>
                      <form method="dialog">
                        <button
                          id="fermer"
                          className="w-8 h-8 flex items-center justify-center rounded-lg bg-red-100 hover:bg-red-200 text-red-600 hover:text-red-600 font-semibold"
                        >
                          ✕
                        </button>
                      </form>
                    </div>
                    <UpdateActivation
                      numeroTicket={numeroTicket}
                      setActive={setActive}
                    />
                  </div>
                </dialog>
              </div>
            </div>
            <div className="my-3 flex justify-end">
              <Pagination
                onChange={(event, newValue) => more(newValue)}
                onSelect={(selectedPage) => more(selectedPage)}
                count={store?.data?.totalPages}
                variant="outlined"
                color="primary"
                shape="rounded"
              />
            </div>
          </>
        ) : null}
      </div>
    </div>
  );
};

export default Installation;
